<template>
    <label class="switch">
        <input type="checkbox" v-model="isToggled" :disabled="disabled" @change="onChangeInput">
        <span class="slider round"></span>
    </label>
</template>

<script>
export default {
    'name': 'ToggleSwitch',
    'props': {
        'checkboxValue': {
            'type': Boolean
        },
        'disabled': {
            'type': Boolean,
            'default': false
        }
    },
    data () {
        return {
            'isToggled': false
        };
    },
    'watch': {
        checkboxValue (val) {
            this.isToggled = val;
        }
    },
    mounted () {
        this.isToggled = this.checkboxValue;
    },
    'methods': {
        onChangeInput () {
            this.$emit('update:checkboxValue', this.isToggled);
        }
    }
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
    margin-bottom: 0;
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #28a745;
}

input:disabled + .slider {
    opacity: .5;
    cursor: not-allowed;
}

input:focus + .slider {
    box-shadow: 0 0 1px #28a745;
}

input:checked + .slider:before {
    transform: translateX(24px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 26px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
